import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=7a148cbc&"
import script from "./_slug.vue?vue&type=script&lang=ts&"
export * from "./_slug.vue?vue&type=script&lang=ts&"
import style0 from "./_slug.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./_slug.vue?vue&type=custom&index=0&blockType=router"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ShowHeader: require('/tmp/build_71ad00c4/src/components/layout/ShowHeader.vue').default,ShowsStatusBanner: require('/tmp/build_71ad00c4/src/components/shows/StatusBanner.vue').default,BlockShowUpcomingDates: require('/tmp/build_71ad00c4/src/components/block/ShowUpcomingDates.vue').default,ShowsDisclaimer: require('/tmp/build_71ad00c4/src/components/shows/Disclaimer.vue').default,ShowsXScenenBackground: require('/tmp/build_71ad00c4/src/components/shows/XScenenBackground.vue').default,Disclosure: require('/tmp/build_71ad00c4/src/components/misc/Disclosure.vue').default,DynamicContainerProvider: require('/tmp/build_71ad00c4/src/components/DynamicContainer/DynamicContainerProvider.vue').default,CardWorker: require('/tmp/build_71ad00c4/src/components/card/Worker.vue').default,CardWorkerSimple: require('/tmp/build_71ad00c4/src/components/card/WorkerSimple.vue').default,CardReview: require('/tmp/build_71ad00c4/src/components/card/Review.vue').default,BlockRelatedPerformances: require('/tmp/build_71ad00c4/src/components/block/RelatedPerformances.vue').default})
